import { styled } from "@mui/material"

export const ChatInputWrap = styled("div")(({ theme }) => ({
    background: theme.palette.grey[100],
    borderRadius: "0 0 4px 4px",
    padding: "16px",
    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
}))
